import Colors from '@/constants/Colors'
import { Icon, IconProps } from './Icon'

export function CloseIcon(props: Omit<IconProps, 'name'>) {
  return <Icon name="times-circle" size={24} color={Colors.shades[200]} {...props} />
}
